import { Divider, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import {
  TriggerDatasetType,
  TriggerInputDataset,
} from '@/hooks/api/datasets/trigger/useTriggerManualRun.ts';
import PreviouslyUploadedFiles from '../PreviouslyUploadedFiles/PreviouslyUploadedFiles.tsx';
import { ManualTriggerInput } from '@/types/automationSteps.ts';
import { RelativeFile } from '@/types/common.ts';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import UploadMultiFiles from '@/pages/AutomationPage/components/ManualRunModal/components/UploadMultiFiles.tsx';
import ManualTriggerInputHeader from './ManualTriggerInputHeader.tsx';

type props = {
  automationId: string;
  trigger: ManualTriggerInput;
  triggerDataset: TriggerInputDataset;
  setTriggerDataset: (d: TriggerInputDataset) => void;
  isLoading: boolean;
};

const HEADER_SPACING = '4px';

const FolderDatasetInput = ({
  automationId,
  trigger,
  triggerDataset,
  setTriggerDataset,
  isLoading,
}: props) => {
  const [uploadNewFiles, setUploadNewFiles] = useState(true);

  useEffect(() => {
    setUploadNewFiles(triggerDataset.type !== TriggerDatasetType.Existing);
  }, [triggerDataset.type]);

  const files = 'files' in triggerDataset && triggerDataset.files ? triggerDataset.files : [];

  const name = 'name' in triggerDataset && triggerDataset.name ? triggerDataset.name : '';

  const setFiles = (_files: RelativeFile[], _name?: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      files: _files,
      type: TriggerDatasetType.Directory,
      name: name || _name || '',
    });
  };

  const setName = (newName: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      files: files,
      type: TriggerDatasetType.Directory,
      name: newName,
    });
  };

  const selectedExistingDatasetId =
    'dataset_id' in triggerDataset ? triggerDataset.dataset_id : undefined;
  const setSelectedExistingDatasetId = (id: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      dataset_id: id,
      type: TriggerDatasetType.Existing,
    });
  };

  return (
    <>
      <Divider style={{ color: '#ececec', borderTopWidth: '0.5px' }} />
      <Stack gap={0}>
        <CustomLoadingOverlay visible={isLoading} />

        <ManualTriggerInputHeader
          trigger={trigger}
          actionLabel={
            uploadNewFiles
              ? 'or use previously uploaded files/folders'
              : 'or upload new files/folders'
          }
          onActionClick={() => setUploadNewFiles(!uploadNewFiles)}
        />

        <Stack gap={0} mt={HEADER_SPACING}>
          {uploadNewFiles && (
            <>
              <UploadMultiFiles files={files} setFiles={setFiles} />

              <StyledTextInput
                label="Folder Name"
                placeholder="Enter folder name"
                size="sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
                // required={files.length > 0 && trigger.is_required}
                required={false} // defaults to the trigger input name
                mt={'md'}
                maxLength={128}
              />
            </>
          )}
          {!uploadNewFiles && (
            <PreviouslyUploadedFiles
              automationId={automationId}
              manualTrigger={trigger}
              selectedExistingDatasetId={selectedExistingDatasetId}
              setSelectedExistingDatasetId={setSelectedExistingDatasetId}
            />
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default FolderDatasetInput;
